import SalaryConfig from "./SalaryConfig";

export default class SalaryService {
	static createSalary(value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = SalaryConfig.endpoint;
				let response = await SalaryConfig.APIConnector.post(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static updateSalary(value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = SalaryConfig.endpoint;
				let response = await SalaryConfig.APIConnector.put(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static deleteSalary(idSalary) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = SalaryConfig.endpoint + `?idSalary=${idSalary}`;
				let response = await SalaryConfig.APIConnector.delete(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/Salary/SalaryService.js